import React from 'react'
import { Notification } from 'react-admin';

const AppNotification = props => <Notification {...props} />;

export default AppNotification